module.exports = __webpack_public_path__ + "static/media/veneto-village-08.ecd1ed33.jpg";